
<script>
export default {
  mounted () {
    window.addEventListener('scroll', this.scrollListener, true)
    window.addEventListener('resize', this.scrollListener, true)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll, true)
    window.removeEventListener('resize', this.handleScroll, true)
  }
}
</script>


// WEBPACK FOOTER //
// src/components/mixins/BackTop.vue